import { Euler } from 'three';

const CONTACT_SHADOW_ROTATION = new Euler(-Math.PI / 2, 0, 0);
const CONTACT_SHADOW_GROUND_OFFSET = 0.002;
const CONTACT_SHADOW_OPACITY = 0.22;

export default function ContactShadow() {
  return (
    <mesh
      position={[0, CONTACT_SHADOW_GROUND_OFFSET, 0]}
      rotation={CONTACT_SHADOW_ROTATION}
      scale={[10, 10, 10]}
      receiveShadow
      renderOrder={-1}
      name="ContactShadow"
    >
      <planeGeometry args={[5, 5]} />
      <shadowMaterial
        color={[0, 0, 0]}
        opacity={CONTACT_SHADOW_OPACITY}
        depthWrite={false}
      />
    </mesh>
  );
}
